<template>
  <div id="app">
    <CampaignBanner />
    <router-view/>
  </div>
</template>

<script>
import CampaignBanner from './components/CampaignBanner.vue'

export default {
  name: "App",
  components: {
    CampaignBanner
  }
}
</script>

<style src="./main.css"></style>